import { useNavigate } from "react-router-dom";
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import ActionButton from "../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import BlueTableHeading from "../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading";
import GrayDivider from "../../../common/AdminCommonComponents/GrayDivider/GrayDivider";

const BillingAndInvoice = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: "View",
      action: () =>
        navigate("/fbm-management/view-billing-and-invoicing-detail"),
    },
  ];

  const tableData = [
    {
      sr: "1",
      invoiceId: "INV-1001",
      partnerName: "ABC logistics",
      billingCycle: "Monthly",
      totalRevenue: "$20,000",
      freeAmount: "$4,500",
      netPayable: "$20,000",
    },
    {
      sr: "2",
      invoiceId: "INV-1001",
      partnerName: "global warehouse",
      billingCycle: "Quarterly",
      totalRevenue: "$20,000",
      freeAmount: "$4,500",
      netPayable: "$20,000",
    },
    {
      sr: "3",
      invoiceId: "INV-1001",
      partnerName: "ABC logistics",
      billingCycle: "Monthly",
      totalRevenue: "$20,000",
      freeAmount: "$4,500",
      netPayable: "$20,000",
    },
    {
      sr: "4",
      invoiceId: "INV-1001",
      partnerName: "global warehouse",
      billingCycle: "Quarterly",
      totalRevenue: "$20,000",
      freeAmount: "$4,500",
      netPayable: "$20,000",
    },
    {
      sr: "5",
      invoiceId: "INV-1001",
      partnerName: "ABC logistics",
      billingCycle: "Monthly",
      totalRevenue: "$20,000",
      freeAmount: "$4,500",
      netPayable: "$20,000",
    },
  ];

  const columns = [
    { name: "Sr", selector: (row) => row.sr, grow: 0.5 },
    { name: "Invoice ID", selector: (row) => row.invoiceId, grow: 0.5 },
    { name: "Partner Name", selector: (row) => row.partnerName },
    { name: "Billing Cycle", selector: (row) => row.billingCycle },
    { name: "Total Revenue", selector: (row) => row.totalRevenue },
    { name: "Free Amount", selector: (row) => row.freeAmount },
    { name: "Net Payable", selector: (row) => row.netPayable },
    { name: "Action", cell: () => <ActionButton options={actions} /> },
  ];

  return (
    <div className="bg-white shadow mt-3">
      <BlueTableHeading className='px-4 py-3 fw-semibold fs-5'>Billing & Invoice</BlueTableHeading>
      <GrayDivider />
      <div className="p-3">
        <DynamicDatatable
          data={tableData}
          columns={columns}
          type="gray"
          pagination
        />
      </div>
    </div>
  );
};

export default BillingAndInvoice;